import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getCurrentUser } from '@/api/auth';

import { RequiredDocumentSection } from '@/types/document';
import { User } from '@/types/user';

type GetCurrentUserResponse = {
  user: User;
  requiredSections: RequiredDocumentSection[];
  time: number;
};

export function useGetCurrentUser(
  options?: Omit<
    UseQueryOptions<GetCurrentUserResponse>,
    'queryKey' | 'queryFn'
  >,
) {
  const query = useQuery<GetCurrentUserResponse>({
    queryKey: ['currentUser'],
    queryFn: () => getCurrentUser(true),
    retry: false,
    refetchOnWindowFocus: true,
    enabled: false,
    ...(options ?? {}),
  });

  return query;
}
